module.exports = __webpack_public_path__ + "static/上海市守合同重信用企业证书-e5580aad89a049dd3c056b76dc66a838.jpg";